<app-forgot-password
  [visibleDialog]="showforgotPasswordDialog"
  (closeForgotPassword)="changeVisibleForgotPasswordDialog($event)"
></app-forgot-password>

<div class="surface-card p-4 mx-auto w-full" style="max-width: 480px;">
  <form
    [formGroup]="loginForm"
    [style]="{
      'padding-bottom': paddingB
    }"
  >
    <div id="loginTitle" class="text-center font-title mb-4">
      Sign in
    </div>

    <div class="text-center mb-4">
      <span class="text-white-alpha-80">No account yet? </span>
      <a href="/landing"
         class="ml-1 unified-link font-medium"
      >Request a demo</a>
    </div>

    <div class="mt-3 w-full">
      <span class="p-float-label p-input-icon-right block w-full">
        <i class="pi pi-envelope"></i>
        <input
          id="username"
          type="text"
          pInputText
          autocomplete="off"
          [class]="
            invalidField('username')
              ? 'ng-invalid ng-dirty w-full p-inputtext-lg custom-input'
              : 'w-full p-inputtext-lg custom-input'
          "
          formControlName="username"
        />
        <label htmlFor="username">Email</label>
      </span>
      <span
        class="block p-error"
        *ngIf="
          invalidField('username') &&
          !loginForm.get('username').hasError('pattern')
        "
        id="username-help"
        >Email is a required field.</span
      >
      <span
        class="p-error block"
        *ngIf="loginForm.get('username').hasError('pattern')"
      >
        Enter a valid email address
      </span>

      <div class="space"></div>

      <span class="p-float-label p-input-icon-right block w-full mt-3">
        <i
          [class]="showPassword ? 'pi pi-eye password-toggle-icon' : 'pi pi-eye-slash password-toggle-icon'"
          (click)="togglePasswordVisibility()"
        ></i>
        <input
          id="password"
          [type]="showPassword ? 'text' : 'password'"
          autocomplete="off"
          pInputText
          [class]="
            invalidField('password')
              ? 'ng-invalid ng-dirty w-full p-inputtext-lg custom-input'
              : 'w-full p-inputtext-lg custom-input'
          "
          formControlName="password"
          (keydown.enter)="enterKeyPress($event)"
        />
        <label htmlFor="password">Password</label>
      </span>
      <span
        class="block p-error"
        *ngIf="invalidField('password')"
        id="password-help"
        >Password is a required field.</span
      >

      <div class="flex w-full justify-content-center mt-4">
        <button
          id="loginBtn"
          [disabled]="isLogging"
          pButton
          pRipple
          label="Sign In"
          class="p-button-lg w-full custom-primary-btn"
          (click)="loginWithTechnews()"
        ></button>
      </div>

      <div class="flex w-full justify-content-between mt-3 text-orange">
        <a
          href="mailto:support@technews.io"
          class="unified-link font-medium"
          >Support</a
        >
        <a
          (click)="showForgotPasswordDialog()"
          class="unified-link font-medium"
          >Forgot Password?</a
        >
      </div>
    </div>

    <div class="space-xl"></div>

    <div class="flex w-full justify-content-center mb-2">
      <button
        icon="pi pi-google"
        pButton
        pRipple
        label="Sign in with Google"
        class="p-button-lg w-full btn-social"
        (click)="loginWithGoogle()"
      ></button>
    </div>

    <div class="flex w-full justify-content-center mb-2">
      <button
        icon="pi pi-linkedin"
        pButton
        pRipple
        label="Sign in with LinkedIn"
        class="p-button-lg w-full btn-social"
        (click)="loginWithLinkedIn()"
      ></button>
    </div>
  </form>
</div>
